export default "__VITE_ASSET__CH5g3RGS__"